import { Box, Button, Card, CardMedia, Checkbox, Grid, Stack, TextField, Typography } from '@mui/material';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../../../../../../libs/Context';

import CountDownTimer from './CountDownTimer';
import { generateRandomUUID } from '../../../../../../../libs/HelperContent';

const PreviewRight = (props) =>
{
	const { data } = props;
	const { language } = useContext(LanguageContext);
	const imageUrl = `${process.env.REACT_APP_S3_BASE_URL}/${data?.bannerImage[0]?.key}`;
	const [ register, setRegister ] = useState(false);
	// const [ input, setInput ] = useState({});
	const webinarDate = new Date(data?.startTimeUTC);
	const date = new Date(webinarDate).getDate();
	const monthYear = moment(webinarDate).format('MMM YYYY');
	const startTime = moment(webinarDate).format('hh:mm A');
	const endTime = moment(data?.startTimeUTC + data?.duration * 60 * 1000).format('hh:mm A');

	// const handleInput = (e) =>
	// {
	// 	const key = e.target.id;
	// 	const val = e.target.value;

	// 	setInput({ ...input, [key]: val });
	// };

	const cardStyle = {
		transition   : 'background-color 1s linear',
		boxShadow    : '0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset',
		borderRadius : '8px 8px 0px 0px',
		// backgroundColor : bgColor,
		width        : 'var(--percent100)',
		height       : 'var(--percent100)'
	};
	const mediaStyle = {
		height : 'var(--percent100)',
		width  : 'var(--percent100)'
	};

	const handleRegister = () =>
	{
		setRegister(!register);
	};

	return (

		<Grid container flex={1}
			sx={{
				backgroundColor : 'var(--whiteColor)',
				borderRadius    : 'var(--pixel8)',
				width           : 'var(--percent100)',
				height          : 'var(--percent100)',
				flexWrap        : 'nowrap',
				flexDirection   : 'column'
			}}
		>
			<Grid item height={'225px'}>
				<Card style={cardStyle}>
					<CardMedia
						component='img'
						image={imageUrl}
						alt='slide'
						style={mediaStyle}
					/>
				</Card>
			</Grid>
			<Grid item pb={3} mt={2}>
				<Typography textAlign={'center'} width={'var(--percent100)'} whiteSpace={'nowrap'} overflow={'hidden'} fontSize={'var(--pixel18)'} fontWeight='var(--font500)' textOverflow={'ellipsis'} px='var(--pixel8)'>{data?.meetingName}</Typography>
				<Stack direction={'column'} alignItems={'center'}>
					<Stack direction={'row'} spacing={1} py='var(--pixel8)' alignItems={'center'}>
						<Grid sx={{ position: 'relative', display: 'flex', alignItems: 'flex-end' }} pr='var(--pixel4)'>
							<Box sx={{ width: '26px', height: '26px' }}><img src='/images/icons/calendericon.svg' style={{ fontSize: 30 }} alt='Calender-Icon' color='#979797'/></Box>
							<Typography
								variant='caption'
								style={{
									position   : 'absolute',
									top        : '55%',
									left       : '41%',
									transform  : 'translate(-50%, -50%)',
									fontWeight : 'bold',
									color      : '#979797'
								}}
							>
								{date}
							</Typography>
						</Grid>
						<Typography variant='body2' borderRight={'1px solid gray'} pr='var(--pixel8)' fontWeight='var(--font500)' lineHeight={'var(--pixel10)'}>{monthYear}</Typography>
						<Typography variant='body2' fontWeight='var(--font500)'>{startTime} - {endTime}</Typography>
					</Stack>
					<CountDownTimer/>
				</Stack>
			</Grid>
			{!register &&
				<Grid item p='var(pixel32)'>
					<Grid item pt='var(--pixel16)' width={'var(--percent100)'} display={'flex'} justifyContent={'center'} textAlign={'center'} flexDirection={'column'}>
						<Typography variant='h6' fontWeight='var(--font600)'>{language.registerevent}</Typography>
						<Typography fontSize={'var(--pixel12)'} py='var(--pixel8)'>{language?.fillFormRegster}</Typography>
						<Stack direction={'column'} display={'flex'} py='var(--pixel8)' justifyContent={'center'} spacing={2} width={'var(--percent100)'}>
							{[ ...(data?.registrationFields || []) ]?.map((item, ind) =>
								(
									<TextField
										key={`reg-${item?._id ?? generateRandomUUID()}`}
										id={`input${ind}`}
										label={`${item?.field}${item?.isRequired ? '*' : ''}`}
										variant='filled'
										// value={input[`input${ind}`]}
										// onChange={handleInput}
										value=''
										size='small'
										sx={{
											'& .MuiFilledInput-root' : {
												backgroundColor : 'var(--lightGrayf6)'
											},
											'& .MuiFilledInput-root:hover' : {
												backgroundColor : 'var(--lightGrayf6)'
											},
											'& .MuiFilledInput-root.Mui-focused' : {
												backgroundColor : 'var(--lightGrayf6)'
											}
										}}
									/>
								))}
							<Stack direction='row' alignItems='center' my='var(--pixel8)'>
								<Checkbox />
								<Typography variant='body2'>
									I’ve read and accept the
									<Typography component='span' color='primary' sx={{ cursor: 'pointer' }} variant='body2'>
										Terms &amp; Conditions
									</Typography>
								</Typography>

							</Stack>
							<Stack direction={'row'} alignItems={'center'} justifyContent={'center'} pt='var(--pixel16)'>
								<Button
									style={{
										width : '60%',
										color : 'white'
										// opacity       : enterval.length > 0 ? '' : '0.5',
										// pointerEvents : enterval.length > 0 ? 'auto' : 'none'
									}}
									variant='contained'
									onClick={handleRegister}
								>
									{language.register}
								</Button>
							</Stack>
						</Stack>
					</Grid>
				</Grid>
			}
			{register &&

			<Grid container justifyContent={'center'} alignItems={'center'}>
				<Grid item xs={12} >
					{!data?.anonymousAccess && !data?.moderation &&
					<Stack direction={'column'} spacing={1} alignItems={'center'} justifyContent={'center'}>
						<Box sx={{ height: '70px', width: '70px' }}
							component='img'
							src='/images/icons/pendingregistration.svg'
						/>
						<Stack direction={'column'} spacing={1} justifyContent={'center'} alignItems={'center'}>
							<Typography fontWeight='var(--font500)' fontSize={'var(--pixel18)'}>{language?.thankYou}</Typography>
							<Typography fontWeight='var(--font500)' fontSize={'var(--pixel24)'}>{language?.reqstSub}</Typography>
							<Typography fontSize={'var(--pixel14)'} color={'rgba(126, 146, 162, 1)'} textAlign={'center'}>{language?.webinarDetailsMail}</Typography>
						</Stack>
					</Stack>
					}
					{!data?.anonymousAccess && data?.moderation &&
					<Stack direction={'column'} spacing={2} alignItems={'center'} justifyContent={'center'}>
						<Box sx={{ height: '70px', width: '70px' }}
							component='img'
							src='/images/icons/successregistration.svg'
						/>
						<Stack direction={'column'} spacing={1} justifyContent={'center'} alignItems={'center'}>
							<Typography fontWeight='var(--font500)' fontSize={'var(--pixel18)'}>{language?.thankYou}</Typography>
							<Typography fontWeight='var(--font500)' fontSize={'var(--pixel24)'}>{language?.sucesfulyRegistered}</Typography>
							<Typography fontSize={'var(--pixel14)'} color={'rgba(126, 146, 162, 1)'}>{language?.webinarLinkEmail} </Typography>
						</Stack>
					</Stack>
					}
					{data?.anonymousAccess &&
					<Stack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2} height={'var(--percent100)'}>
						<Stack direction={'row'} spacing={1} pt='var(--pixel16)'>
							<Typography>Hello</Typography>
							<Typography sx={{ fontWeight: '700' }}>Praveen Kumar Gavallapalli</Typography>
						</Stack>
						<Typography pb='var(--pixel8)'>
							{language?.stayTunedWebinar}
						</Typography>
						<Button variant='contained' color='primary' disableElevation
							sx={{
								color : '#ffffff',
								width : '60%'
							}}
						>{language?.joinWebinar}</Button>
					</Stack>}
				</Grid>
			</Grid>

			}
		</Grid>

	);
};

export default PreviewRight;